<template>
    <t-space direction="vertical" style="width: 100%;" size="small">
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点说明" 
                    brodered 
                    style="width: 85vw;height: 13vh;" 
                    :hoverShadow="true">
                    <t-typography-text>通过创建盘点任务单，进行盘点任务</t-typography-text>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点任务列表" 
                    brodered 
                    style="width: 85vw;" 
                    :hoverShadow="true">
                    <t-space direction="vertical">
                        <t-button theme="primary"  @click="createTask">创建库存盘点任务</t-button>
                        <t-space>
                            <t-input v-model="searchTaskId" placeholder="请输入盘点任务编号" ></t-input>
                            <t-input v-model="searchTaskName" placeholder="请输入盘点任务名称" ></t-input>
                            <t-input v-model="searchTaskCreator" placeholder="请输入创办人" ></t-input>
                            <t-date-range-picker v-model="searchDate"  enable-time-picker />  
                            <t-button variant="outline" :icon="renderIcon" theme="primary"  @click="Search">搜索</t-button>
                        </t-space>
                        <t-table
                            row-key="index"
                            :pagination="pageConfig" 
                            :columns="columns"
                            :data="taskList">
                        </t-table>
                    </t-space>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>
    </t-space>
</template>

<script lang="jsx" setup>
import router from '@/router/main';
import request from '@/request/request';
import { onMounted,ref } from 'vue';
import { NotifyPlugin } from 'tdesign-vue-next';
import { ErrorCircleFilledIcon, CheckCircleFilledIcon } from 'tdesign-icons-vue-next';
import { SearchIcon } from 'tdesign-icons-vue-next';
const renderIcon = () => {
    return <SearchIcon />;
}
const searchDate = ref([])
const searchTaskId = ref("")
const searchTaskName = ref("")
const searchTaskCreator = ref("")
const searchFlag = ref(false)
const columns = [
    {title: '任务编号',colKey: "id"},
    {title: '所属仓库',colKey: "bindingWarehouseName"},
    {title: '任务名称',colKey: "name"},
    {title: '任务状态',colKey: "status",
    cell: (h, { row }) => {
            const statusNameListMap = {
                0: { label: '已完成', theme: 'success', icon: <CheckCircleFilledIcon /> },
                1: { label: '进行中', theme: 'warning', icon: <ErrorCircleFilledIcon /> },
            }
            let index = -1
            if(row.status === "已完成") index = 0
            else if(row.status === "进行中") index = 1
            return (
                <t-tag  theme={statusNameListMap[index].theme} variant="light-outline">
                    {statusNameListMap[index].icon}
                    {statusNameListMap[index].label}
                </t-tag>
            )
        }
    },
    {title: '创办人',colKey: "creator"},
    {title: '创建时间',colKey: "createTime"},
    {title: '任务描述',colKey: "description"},
    {title: '操作',
    colKey: "action",
    fixed: 'right',
    cell: (h, { row }) => {
            return (
                <t-space class="table-operations" space="small">
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={taskDetails}>
                        详情 
                    </t-link>
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={deleteTask}>
                        删除
                    </t-link>
                </t-space>
            );
        }
    }
]
const pageConfig = ref({
    pageSize: 8,
    defaultPageSize: 8,
    total: 8,
    defaultCurrent: 1,
    showPageSize: false,
    onCurrentChange: (number)=>{
        if(searchFlag.value) {
            let params = {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                page_number: number,
                page_size: pageConfig.value.pageSize,
                task_id: searchTaskId.value,
                task_creator: searchTaskCreator.value,
                task_name: searchTaskName.value,
                begin_time: searchDate.value[0],
                end_time: searchDate.value[1]
            }
            request.SearchWarehouseCheckTask(params,(res)=>{
                if(res.data.success) {
                    pageConfig.value.total = res.data.data.total
                    taskList.value = res.data.data.list
                    for(let i = 0; i < taskList.value.length; i++) {
                        taskList.value[i].index = i
                    }
                }else {
                    NotifyPlugin.error({
                        title: "请求失败",
                        content: '获取任务列表失败.',
                        duration: 3000
                    })
                }
            },(err)=>{
                NotifyPlugin.error({
                    placement: 'top-right',
                    title: '数据请求错误',
                    content: '数据请求失败，其联系管理人员\n' + err,
                    duration: 3000,
                })
            })
        } else {
            request.RequestWarehouseCheckTaskQuery(number,pageConfig.value.pageSize,(res)=>{
            if(res.data.success) {
                taskList.value = res.data.data
                for(let i = 0; i < taskList.value.length; i++) {
                    taskList.value[i].index = i
                }
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败.',
                    duration: 3000
                })
            }
            },(err)=>{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败.' + err,
                    duration: 3000
                })
            })
        }
    }
})
const taskList = ref()
const Search =()=>{
    searchFlag.value = true
    let params = {
        binding_user_id: parseInt(sessionStorage.getItem("user_id")),
        page_number: 1,
        page_size: pageConfig.value.pageSize,
        task_id: searchTaskId.value,
        task_creator: searchTaskCreator.value,
        task_name: searchTaskName.value,
        begin_time: searchDate.value[0],
        end_time: searchDate.value[1]
    }
    request.SearchWarehouseCheckTask(params,(res)=>{
        if(res.data.success) {
            pageConfig.value.total = res.data.data.total
            taskList.value = res.data.data.list
            for(let i = 0; i < taskList.value.length; i++) {
                taskList.value[i].index = i
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '获取任务列表失败.',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '数据请求错误',
            content: '数据请求失败，其联系管理人员\n' + err,
            duration: 3000,
        })
    })
}
const taskDetails = (e)=>{
    let {id} = e.currentTarget.dataset
    sessionStorage.setItem("warehouse_task_step",2)
    sessionStorage.setItem("warehouse_check_task_id",taskList.value[id].id)
    router.push('/home/warehouse_check_create')
}
const deleteTask = (e)=>{
    let {id} = e.currentTarget.dataset
    
    request.DelectWarehouseCheckTask(taskList.value[id].id,(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "删除成功",
                content: '任务删除成功',
                duration: 3000
            })
            taskList.value.splice(id,1)
            for(let i = 0; i < taskList.value.length; i++) {
                taskList.value[i].index = i
            }
        }else{
            NotifyPlugin.error({
                title: "删除失败",
                content: '任务删除失败.',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "删除失败",
            content: '任务删除失败.' + err,
            duration: 3000
        })
    })
}
const createTask = ()=>{
    sessionStorage.setItem("warehouse_task_step",0)
    router.push('/home/warehouse_check_create')
}

onMounted(()=>{
    request.RequestWarehouseCheckTaskQuery(0,8,(res)=>{
        if(res.data.success) {
            taskList.value = res.data.data
            for(let i = 0; i < taskList.value.length; i++) {
                taskList.value[i].index = i
            }
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败.',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '任务列表请求失败.' + err,
            duration: 3000
        })
    })
    request.getWarehouseCheckTaskAmount((res)=>{
        if(res.data.success) {
            pageConfig.value.total = res.data.data
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '获取任务数量失败。',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '任务列表请求失败.' + err,
            duration: 3000
        })
    })
})
</script>
<style scoped>

</style>